// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { Manufacturer } from './manufacturer';
import { PricedProductType } from './priced-product-type';
import { Product } from './product';
import { ProductTypeFeature } from './product-type-feature';
import { ProductTypeImage } from './product-type-image';
import { ProductTypeTagMap } from './product-type-tag-map';
import { StockCondition } from './stock-condition';
import { Supplier } from './supplier';
import { ActiveStatusEnum } from './enums';
import { StockConditionEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import * as _ from 'lodash';
import { Feature } from './feature';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getStatusParents() {
    return [this.manufacturer];
  }

  getStatusId() {
    return this.activeStatusId;
  }

  getWorkingFeatureOnStatus(): Feature | null {
    if (!this.productTypeFeatures || this.productTypeFeatures.length == 0) return null;
    if (this.productTypeFeatures.length === 1) return this.productTypeFeatures[0].feature;
    let selected = this.productTypeFeatures[0].feature;
    this.productTypeFeatures.forEach((pf) => {
      if (pf && pf.feature) {
        if (pf.feature.activeStatusId > selected.activeStatusId) {
          selected = pf.feature;
        }
      }
    });
    return selected;
  }

  // requires that productTypeFeatures have been queries
  getOrderedProductTypeFeatures() {
    return _.orderBy(this.productTypeFeatures, (x) => x.displayOrder);
  }

  getAllFeatures() {
    return this.getOrderedProductTypeFeatures()
      .map((pf) => pf.feature?.getDisplayName() + ': ' + pf.feature?.name)
      .join(', ');
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(200) */
  apiLink?: string;
  /** String */
  description!: string;
  /** Int32 */
  leadTimeDays!: number;
  /** Guid FK manufacturer */
  manufacturerId!: string;
  /** String(60) */
  name!: string;
  /** String(200) */
  productKey?: string;
  /** Binary */
  rowVersion!: any;
  /** Enum FK stockCondition */
  stockConditionId!: StockConditionEnum;
  /** Guid FK supplier */
  supplierId!: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
  /** Inv FK productTypeId */
  pricedProductTypes!: PricedProductType[];
  /** Inv FK productTypeId */
  productTypeFeatures!: ProductTypeFeature[];
  /** Inv FK productTypeId */
  productTypeImages!: ProductTypeImage[];
  /** Inv FK productTypeId */
  productTypeTagMaps!: ProductTypeTagMap[];
  /** Inv FK productTypeId */
  products!: Product[];
  /** FK stockConditionId */
  stockCondition!: StockCondition;
  /** FK supplierId */
  supplier!: Supplier;
}

